import {
  Grid,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { InputV2, Icons, LabelWithToolTip, CommonTooltip, UploadCropperImage } from 'components';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
const MainForm = ({
  methods,
  classes,
  setLogo,
  logo,
  state,
  setState,
  checkboxGroup,
  setCheckBoxGroup,
}) => {
  return (
    <>
      <Grid container item xs={12}>
        <Grid container item xs={12} md={6}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="name"
                onChangeValue={(e) => {
                  setState({ ...state, name: e.target.value });
                }}
                forceValue={state.name ?? ''}
                label="نام اپلیکیشن/وب‌سایت"
                register={{}}
                rules={['required']}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="url"
                onChangeValue={(e) => {
                  setState({ ...state, url: e.target.value });
                }}
                forceValue={state.url ?? ''}
                label="آدرس وب‌سایت"
                register={{}}
                rules={['required', 'isURL']}
                fullWidth
                dir="ltr"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="supportNumber"
                onChangeValue={(e) => {
                  setState({ ...state, supportNumber: e.target.value });
                }}
                forceValue={state.supportNumber ?? ''}
                label="شماره تماس پشتیبانی"
                tooltip="این شماره برای بررسی مشکلات کاربران استفاده می‌شود."
                defaultValue=""
                rules={['required', 'isNumeric']}
                englishNumber
                fullWidth
                dir="ltr"
                register={{}}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="appHash"
                onChangeValue={(e) => {
                  setState({ ...state, appHash: e.target.value });
                }}
                forceValue={state.appHash ?? ''}
                label="هش اپلیکیشن اندرویدی"
                tooltip="تنظیم کد ارسالی برای ورود به سیستم OTP بدون نیاز به خواندن پیام کوتاه (در Android)"
                defaultValue=""
                rules={['isAppHash']}
                englishNumber
                fullWidth
                dir="ltr"
                register={{}}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="description"
                onChangeValue={(e) => {
                  setState({ ...state, description: e.target.value });
                }}
                forceValue={state.description ?? ''}
                label="توضیحات/معرفی کسب‌وکار"
                defaultValue=""
                fullWidth
                multiline
                inputProps={{ style: { minHeight: 100 } }}
                register={{}}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <CommonTooltip title="تصویر لوگو که به کاربر نمایش داده خواهد شد، در اینجا بارگذاری می‌شود.(حداکثر حجم 1 مگابایت). بارگذاری لوگو در اینجا، الزامی است.">
            <span style={{ position: 'absolute', left: '50px', zIndex: '10' }} >
              <Icons icon='Info' color='#667585' hover='#667585' size='20' />
            </span>
          </CommonTooltip>
          <div style={{display: 'flex',justifyContent: ' flex-end'}}>
          <UploadCropperImage
            title="تصویر لوگو کسب‌و‌کار"
            name="cover"
            volumeFile={1}
            onChange={(url) => setLogo(url)}
            value={logo}

          />
          </div>
        
        </Grid>
      </Grid>

      <FormControl component="fieldset" style={{ width: '100%', marginInlineStart: 10 }}>
        <FormGroup className={classes.formControl}>
          <Grid container item xs={12} spacing={3}>
            <Grid item>
              <Controller
                name="implicitAllowed"
                control={methods.control}
                defaultValue={false}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Boolean(field.value)}
                        onChange={(event) => field.onChange(event.target.checked)}
                        icon={<CheckBoxIcon />}
                        checkedIcon={<CheckBoxIconFill />}
                      />
                    }
                    label={
                      <LabelWithToolTip
                        label="توکن یک مرحله‌ای"
                        description="توکن یک مرحله‌ای به این معناست که بلافاصله پس از ورود کاربرتان، توکن دسترسی او را دریافت خواهید کرد یا با استفاده از Code وارد فرایند دریافت refresh_token می‌شوید. برای امنیت بیشتر توصیه می‌گردد اجازه توکن یک مرحله‌ای ندهید."
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item>
              <Controller
                name="captchaEnabled"
                control={methods.control}
                defaultValue={false}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Boolean(field.value)}
                        onChange={(event) => field.onChange(event.target.checked)}
                        icon={<CheckBoxIcon />}
                        checkedIcon={<CheckBoxIconFill />}
                      />
                    }
                    label={
                      <LabelWithToolTip
                        label="نمایش عبارت تصادفی"
                        description="مشخص می‌کند که آیا عبارت تصادفی(captcha) برای ورود مشتری کسب‌وکار نمایش داده شود یا خیر."
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                value={checkboxGroup.signupEnabled}
                control={
                  <Checkbox
                    onChange={(e) =>
                      setCheckBoxGroup({ ...checkboxGroup, signupEnabled: e.target.checked })
                    }
                    checked={checkboxGroup.signupEnabled}
                    value={checkboxGroup.signupEnabled}
                    defaultChecked={false}
                    icon={<CheckBoxIcon />}
                    checkedIcon={<CheckBoxIconFill />}
                  />
                }
                label={
                  <LabelWithToolTip
                    label="اجازه ثبت‌نام کاربر"
                    description="در این بخش مشخص می‌کنید که آیا اجازه ثبت‌نام کاربر را برای حساب کسب‌وکاری خود می‌دهید یا خیر"
                  />
                }
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                value={checkboxGroup.pkceEnabled}
                control={
                  <Checkbox
                    onChange={(e) =>
                      setCheckBoxGroup({ ...checkboxGroup, pkceEnabled: e.target.checked })
                    }
                    checked={checkboxGroup.pkceEnabled}
                    value={checkboxGroup.pkceEnabled}
                    defaultChecked={false}
                    icon={<CheckBoxIcon />}
                    checkedIcon={<CheckBoxIconFill />}
                  />
                }
                label={
                  <LabelWithToolTip
                    label="ورود به صورت PKCE"
                    description="این پارامتر به کلاینت اجازه ی استفاده از روش PKCE داده می شود"
                  />
                }
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                value={checkboxGroup.cssEnabled}
                control={
                  <Checkbox
                    onChange={(e) =>
                      setCheckBoxGroup({ ...checkboxGroup, cssEnabled: e.target.checked })
                    }
                    checked={checkboxGroup.cssEnabled}
                    value={checkboxGroup.cssEnabled}
                    defaultChecked={false}
                    icon={<CheckBoxIcon />}
                    checkedIcon={<CheckBoxIconFill />}
                  />
                }
                label={
                  <LabelWithToolTip
                    label="امکان افزودن css"
                    description="در این بخش امکان افزودن استایل وجود دارد"
                  />
                }
              />
            </Grid>
          </Grid>
        </FormGroup>
      </FormControl>
    </>
  );
};

export default MainForm;
